import { RootStateData } from '@jurnee/common/src/browser/State';
import { createSlice } from '@reduxjs/toolkit';
import { bootstrap } from '../bootstrap/bootstrap.thunks';

const initialState: RootStateData<boolean> = {
  data: false,
  error: false,
  status: 'INITIAL'
};

const slice = createSlice({
  name: 'partner',
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(bootstrap.pending, () => {
      return {
        data: false,
        error: false,
        status: 'FETCHING'
      };
    });

    builder.addCase(bootstrap.fulfilled, () => {
      return {
        data: true,
        error: false,
        status: 'FETCHED'
      };
    });

    builder.addCase(bootstrap.rejected, () => {
      return {
        data: false,
        error: true,
        status: 'INITIAL'
      };
    });

  }
});

export default slice.reducer;